import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { NgxMatDateFormats, NgxMatNativeDateAdapter } from '@ngxmc/datetime-picker';

export interface DateDisplay {
    year: string;
    month: string;
    day: string;
}

export const CUSTOM_DATETIME_FORMATS: NgxMatDateFormats = {
    parse: {
        dateInput: { month: 'short', year: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' },
    },
    display: {
        dateInput: 'customInput',
        monthYearLabel: { year: 'numeric', month: 'short' },
        dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
        monthYearA11yLabel: { year: 'numeric', month: 'long' },
    },
};

@Injectable()
export class CustomDatetimeAdapter extends NgxMatNativeDateAdapter {
    override parse(value: string): Date | null {
        try {
            let date: Date = null;

            if (this.locale === 'fr') {
                // format: dd/MM/yyyy HH:mm:ss
                const [day, month, yearTime] = value.split('/');
                const [year, time] = yearTime.split(' ');
                const [hours, minutes, seconds] = time.split(':');
                date = new Date(+year, +month - 1, +day, +hours, +minutes, +seconds);
            } else {
                date = new Date(value);
            }

            return date;
        } catch (error) {
            console.log('format erreur');
            return null;
        }
    }

    override format(date: Date, display: string | DateDisplay): string {
        if (display === 'customInput') {
            if (this.locale === 'fr') {
                return new DatePipe(this.locale).transform(date, 'dd/MM/yyyy HH:mm:ss');
            } else {
                return new DatePipe(this.locale).transform(date, 'MM/dd/yyyy HH:mm:ss');
            }
        } else {
            return new DatePipe(this.locale).transform(date, 'MMM yyyy');
        }
    }

    override getFirstDayOfWeek(): number {
        return 1;
    }
}
